import { render, staticRenderFns } from "./staticListByTableColumn.vue?vue&type=template&id=679377c0&"
import script from "./staticListByTableColumn.vue?vue&type=script&lang=js&"
export * from "./staticListByTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/staticListByTableColumn.vue"
export default component.exports